// Framer Motion animation variants for the portfolio

// Hero section animations
export const heroNameVariant = {
  initial: { x: -700, opacity: 0 },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
      delay: 0.5,
    },
  },
};

export const heroNameLineVariant = {
  initial: { x: -450, opacity: 0 },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      delay: 1.2,
      duration: 0.6,
    },
  },
};

export const heroTitleVariant = {
  initial: { y: 40, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      delay: 0.3,
      duration: 0.8,
    },
  },
};

export const heroSubtitleVariant = (delay = 0) => ({
  initial: { x: -100, opacity: 0 },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      delay: 1.5 + delay * 0.2,
    },
  },
});

export const heroButtonsVariant = {
  initial: { y: 40, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      delay: 2.5,
      duration: 0.8,
    },
  },
};

export const scrollDownVariant = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      delay: 3.5,
      duration: 0.8,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

export const scrollDownHoverVariant = {
  hover: {
    y: 6,
    transition: {
      type: 'spring',
      stiffness: 150,
      duration: 0.4,
    },
  },
};

// Tech stack rotating animation
export const techStackRotateVariant = {
  animate: {
    rotate: 360,
    transition: {
      duration: 60,
      ease: 'linear',
      repeat: Infinity,
    },
  },
};

export const techStackCounterRotateVariant = {
  animate: {
    rotate: -360,
    transition: {
      duration: 60,
      ease: 'linear',
      repeat: Infinity,
    },
  },
};

// Section animations
export const fadeInUp = {
  initial: { y: 60, opacity: 0 },
  whileInView: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
      duration: 0.8,
    },
  },
};

export const fadeInLeft = {
  initial: { x: -60, opacity: 0 },
  whileInView: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
      duration: 0.8,
    },
  },
};

export const fadeInRight = {
  initial: { x: 60, opacity: 0 },
  whileInView: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
      duration: 0.8,
    },
  },
};

export const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

export const staggerItem = {
  initial: { y: 20, opacity: 0 },
  whileInView: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
    },
  },
};

// Card hover animations
export const cardHover = {
  rest: {
    scale: 1,
    y: 0,
  },
  hover: {
    scale: 1.02,
    y: -8,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 20,
    },
  },
};

// Project card animations (alternating left/right)
export const projectCardVariant = (isEven) => ({
  initial: { x: isEven ? 60 : -60, opacity: 0 },
  whileInView: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 80,
      damping: 20,
      duration: 0.8,
    },
  },
});

// Floating animation for decorative elements
export const floatAnimation = {
  initial: { y: 0 },
  animate: {
    y: [-10, 10, -10],
    transition: {
      duration: 4,
      ease: 'easeInOut',
      repeat: Infinity,
    },
  },
};

// Pulse glow animation
export const pulseGlow = {
  initial: { boxShadow: '0 0 20px rgba(99, 102, 241, 0.3)' },
  animate: {
    boxShadow: [
      '0 0 20px rgba(99, 102, 241, 0.3)',
      '0 0 40px rgba(99, 102, 241, 0.6)',
      '0 0 20px rgba(99, 102, 241, 0.3)',
    ],
    transition: {
      duration: 2,
      ease: 'easeInOut',
      repeat: Infinity,
    },
  },
};

// Navbar animation
export const navbarVariant = {
  hidden: { y: -100, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
      delay: 0.2,
    },
  },
};

// Email copy animation
export const emailCopyVariant = {
  initial: { scale: 1 },
  tap: { scale: 0.95 },
  hover: {
    scale: 1.02,
    transition: {
      type: 'spring',
      stiffness: 300,
    },
  },
};

// Divider quote animation
export const dividerQuoteVariant = {
  initial: { scale: 0.8, opacity: 0 },
  whileInView: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      delay: 0.3,
    },
  },
};

// Social icon hover
export const socialIconHover = {
  rest: { scale: 1, rotate: 0 },
  hover: {
    scale: 1.15,
    rotate: 5,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 15,
    },
  },
};
